<div class="card-container flex" *ngIf="finalSetupSettingsCopy$ | async as finalSetupSettings">
  <div class="card spacing--margin-all">
    <agr-summary-card title="{{ 'final-setup-setting.title' | translate }}" [canExpand]="false">
      <tr class="spacing--padding-all spacing--margin-left">
        <td>{{ 'final-setup-setting.switch' | translate }}</td>
        <td>
          <mat-slide-toggle
            [hideIcon]="true"
            class="spacing--padding-vertical spacing--padding-left"
            color="primary"
            data-test="setting__final-setup-switch"
            [(ngModel)]="finalSetupSettings.finalSetup"
            (ngModelChange)="updateFinalSetupSettings(finalSetupSettings)"
          >
          </mat-slide-toggle>
        </td>
      </tr>

      <div class="wrapper--spacing-vertical">
        <h6 class="text--h6">{{ 'final-setup-setting.default-settings-title' | translate }}</h6>
        <tr class="spacing--padding-all spacing--margin-left">
          <td>{{ 'final-setup-setting.chick-delivery-switch' | translate }}</td>
          <td>
            <mat-slide-toggle
              [hideIcon]="true"
              class="spacing--padding-vertical spacing--padding-left"
              color="primary"
              data-test="setting__chick-delivery-switch"
              [(ngModel)]="finalSetupSettings.chickDeliveries"
              (ngModelChange)="updateFinalSetupSettings(finalSetupSettings)"
              [disabled]="!finalSetupSettings.finalSetup"
            >
            </mat-slide-toggle>
          </td>
        </tr>

        <tr class="spacing--padding-all spacing--margin-left">
          <td>{{ 'final-setup-setting.feed-delivery-switch' | translate }}</td>
          <td>
            <mat-slide-toggle
              [hideIcon]="true"
              class="spacing--padding-vertical spacing--padding-left"
              color="primary"
              data-test="setting__feed-delivery-switch"
              [(ngModel)]="finalSetupSettings.feedDeliveries"
              (ngModelChange)="updateFinalSetupSettings(finalSetupSettings)"
              [disabled]="!finalSetupSettings.finalSetup"
            >
            </mat-slide-toggle>
          </td>
        </tr>

        <tr class="spacing--padding-all spacing--margin-left">
          <td>{{ 'final-setup-setting.departure-switch' | translate }}</td>
          <td>
            <mat-slide-toggle
              [hideIcon]="true"
              class="spacing--padding-vertical spacing--padding-left"
              color="primary"
              data-test="setting__departures-switch"
              [(ngModel)]="finalSetupSettings.departures"
              (ngModelChange)="updateFinalSetupSettings(finalSetupSettings)"
              [disabled]="!finalSetupSettings.finalSetup"
            >
            </mat-slide-toggle>
          </td>
        </tr>

        <tr class="spacing--padding-all spacing--margin-left">
          <td>{{ 'final-setup-setting.discount-switch' | translate }}</td>
          <td>
            <mat-slide-toggle
              [hideIcon]="true"
              class="spacing--padding-vertical spacing--padding-left"
              color="primary"
              data-test="setting__discounts-switch"
              [(ngModel)]="finalSetupSettings.discounts"
              (ngModelChange)="updateFinalSetupSettings(finalSetupSettings)"
              [disabled]="!finalSetupSettings.finalSetup"
            >
            </mat-slide-toggle>
          </td>
        </tr>
      </div>
    </agr-summary-card>
  </div>

  <div class="card spacing--margin-all">
    <agr-summary-card
      title="{{ 'final-setup-setting.masterdata.title' | translate }}"
      [canExpand]="false"
      class="flex__child--grow"
    >
      <div class="flex--column">
        <div class="spacing--padding-vertical">
          {{ 'final-setup-setting.masterdata.notes' | translate }}
        </div>
        <mat-form-field class="spacing--margin-left">
          <textarea
            matInput
            [cdkTextareaAutosize]="true"
            [cdkAutosizeMinRows]="3"
            data-test="settings__notes"
            [(ngModel)]="finalSetupSettings.masterData.notes"
            (ngModelChange)="updateFinalSetupSettings(finalSetupSettings)"
          ></textarea>
        </mat-form-field>
      </div>

      <tr>
        <td>{{ 'final-setup-setting.masterdata.payer' | translate }}</td>
        <td>
          <mat-form-field class="spacing--margin-left mat-width">
            <input
              matInput
              [(ngModel)]="finalSetupSettings.masterData.payer"
              (ngModelChange)="updateFinalSetupSettings(finalSetupSettings)"
              data-test="settings__payer"
            />
          </mat-form-field>
        </td>
      </tr>
      <tr class="spacing--padding-all">
        <td>{{ 'final-setup-setting.masterdata.payer-email' | translate }}</td>
        <td>
          <mat-form-field class="spacing--margin-left mat-width">
            <input
              matInput
              [(ngModel)]="finalSetupSettings.masterData.payerEmail"
              (ngModelChange)="updateFinalSetupSettings(finalSetupSettings)"
              data-test="settings__payer-email"
            />
          </mat-form-field>
        </td>
      </tr>

      <tr class="spacing--padding-all">
        <td>{{ representativeLabel }}</td>

        <td>
          <mat-form-field class="spacing--margin-left mat-width">
            <input
              matInput
              [(ngModel)]="finalSetupSettings.masterData.representativeAgrifirm"
              (ngModelChange)="updateFinalSetupSettings(finalSetupSettings)"
              data-test="settings__representative-agrifirm"
            />
          </mat-form-field>
        </td>
      </tr>

      <tr class="spacing--padding-all spacing--margin-left">
        <td>{{ 'final-setup-setting.masterdata.separate-stable' | translate }}</td>
        <td>
          <mat-slide-toggle
            [hideIcon]="true"
            class="spacing--padding-vertical spacing--padding-left"
            color="primary"
            [(ngModel)]="finalSetupSettings.masterData.separateStable"
            (ngModelChange)="updateFinalSetupSettings(finalSetupSettings)"
            data-test="setting__separate-stable"
          >
          </mat-slide-toggle>
        </td>
      </tr>

      <tr class="spacing--padding-all spacing--margin-left">
        <td>{{ 'final-setup-setting.masterdata.integration-premium' | translate }}</td>
        <td>
          <mat-slide-toggle
            [hideIcon]="true"
            class="spacing--padding-vertical spacing--padding-left"
            color="primary"
            [(ngModel)]="finalSetupSettings.masterData.integrationPremium"
            (ngModelChange)="updateFinalSetupSettings(finalSetupSettings)"
            data-test="setting__integration-premium"
          >
          </mat-slide-toggle>
          <mat-form-field
            class="discount-value-width spacing--padding-horizontal spacing--margin-left"
          >
            <input
              matInput
              [(ngModel)]="finalSetupSettings.masterData.discountValue"
              (ngModelChange)="updateFinalSetupSettings(finalSetupSettings)"
              data-test="settings__discount-value"
              [disabled]="
                !finalSetupSettings.masterData.integrationPremium &&
                !finalSetupSettings.masterData.agrifirmMember
              "
            />
          </mat-form-field>
          <span class="spacing--padding-horizontal">{{
            'final-setup-setting.masterdata.discount-value' | translate
          }}</span>
        </td>
      </tr>

      <tr class="spacing--margin-left">
        <td>{{ memberLabel }}</td>
        <td>
          <mat-slide-toggle
            [hideIcon]="true"
            class="spacing--padding-left"
            color="primary"
            [(ngModel)]="finalSetupSettings.masterData.agrifirmMember"
            (ngModelChange)="updateFinalSetupSettings(finalSetupSettings)"
            data-test="setting__agrifirm-member"
          >
          </mat-slide-toggle>
        </td>
      </tr>
    </agr-summary-card>
  </div>
</div>
